import { queryOptions } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { MemberDetailSchema, MembersListSchema } from './members-access.contract'
import type { MemberAccessStatus, MemberDetail, MembersList } from './members-access.contract'

export const membersAccessKeys = {
  all: ['members-access'] as const,
  lists: () => [...membersAccessKeys.all, 'list'] as const,
  list: (filters: MembersListFilters) => [...membersAccessKeys.lists(), filters] as const,
  details: () => [...membersAccessKeys.all, 'detail'] as const,
  detail: (memberId: string) => [...membersAccessKeys.details(), memberId] as const,
}

export type MembersListFilters = {
  search?: string
  status?: MemberAccessStatus
  productId?: string
}

export function membersListQuery(filters: MembersListFilters = {}) {
  const params = new URLSearchParams()
  if (filters.search) params.set('search', filters.search)
  if (filters.status) params.set('status', filters.status)
  if (filters.productId) params.set('productId', filters.productId)
  const query = params.toString()
  return queryOptions({
    queryKey: membersAccessKeys.list(filters),
    queryFn: async (): Promise<MembersList> => {
      const data = await apiFetch<unknown>(`/members-area/members${query ? `?${query}` : ''}`)
      return MembersListSchema.parse(data)
    },
  })
}

export function memberDetailQuery(memberId: string) {
  return queryOptions({
    queryKey: membersAccessKeys.detail(memberId),
    queryFn: async (): Promise<MemberDetail> => {
      const data = await apiFetch<unknown>(`/members-area/members/${memberId}`)
      return MemberDetailSchema.parse(data)
    },
    enabled: Boolean(memberId),
  })
}
